module.exports = {"id":"207454","name":"Patricio Rodríguez","rating":"71","photo":"./data/images/photos/4/207454.png","club":{"name":"Newcastle Jets","logo":"./data/images/clubs/NewcastleJets.png"},"positions":["MG","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PatricioRodriguez0.json
// module id = 3375
// module chunks = 0